import React from 'react';
import { DefaultTooltipContent } from 'recharts';

/**
 * Recharts 3: TooltipBoundingBox + getTooltipTranslate houden de tooltip binnen het chart-viewBox
 * zolang allowEscapeViewBox niet true is (standaard false). Geen extra transform hier — die
 * conflicteerde met die positionering en liet tekst afkappen.
 * Alleen leesbare wrapping en max-breedte t.o.v. viewport.
 */
export default function DashboardClampedTooltip(props) {
  const { active, payload, contentStyle } = props;
  if (!active || !payload?.length) {
    return null;
  }

  const mergedContentStyle = {
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
    maxWidth: 'min(22rem, calc(100vw - 1.5rem))',
    ...contentStyle,
  };

  return <DefaultTooltipContent {...props} contentStyle={mergedContentStyle} />;
}
